export default "__VITE_ASSET__3238L1ET__"